import React from 'react';

import { PageTitle } from '@cordata/buffet';

import ReminderGroupsForm from '~/components/ReminderGroup/Form';

const ReminderGroupsAdd = () => (
  <>
    <PageTitle>Add Reminder Group</PageTitle>

    <ReminderGroupsForm />
  </>
);

export default ReminderGroupsAdd;
